/* eslint-disable eqeqeq */
import { gql } from '@apollo/client'

import * as f from '../../../components/BPMTable/BPMInputs'
import { 
    DataMapper,
    TableFieldDescription,
    DateComponentCreator,
    DateTimeComponentCreator,
    DateDisplayCreator,
} from '../../../components/BPMTable/TableMapperCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import {DirectTableQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";


// tableQuery movido al test de DirectTableQueryBuilder

const newMutator = gql`
    mutation createCompanyPeriodMutation($periodId: String) {
        createCompanyPeriod(periodId: $periodId) {
            companyPeriod {
                id
                period {
                    date
                }
            }
        }
    }
`
const unitQuery = `
    companyPeriod(id: $id) {
        id
        period {
            id
            date
            endDate
            startDate
        }
        lastExecutionDate
        timesProcessed
        availProcessses
        publishedProcesses
        subProcessesCount
    }
`

const InvoiceInvoicePeriodsTableCreatorQueries = {tableQueryBuilder: new DirectTableQueryBuilder('allCompanyPeriod'), newMutator, unitQuery}

const companyPeriodActions = {
    'A_0': 'UnPublish',
    'A_1': 'Publish',
}

class InvoiceInvoicePeriodsTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "InvoiceInvoicePeriodsTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, InvoiceInvoicePeriodsTableCreatorQueries)
        tableCreator.setDescriptions([
            new TableFieldDescription(
                'startDate',
                new DataMapper('period.date'),
                new f.FilterDescription(new f.PeriodFilter('startDate', {bounds: f.PERIOD_BOUNDS.COMPANY})),
                {label: ('Period')}
            ),

            new TableFieldDescription(
                'lastExecutionDate',
                new DataMapper('lastExecutionDate'),
                new f.FilterDescription(new f.DateFilter('lastExecutionDate')),
                {label: ('Last Execution'), componentCreator: new DateTimeComponentCreator(), excelDisplay: new DateDisplayCreator()}
            ),
            new TableFieldDescription(
                'timesProcessed',
                new DataMapper('timesProcessed'),
                new f.FilterDescription(new f.NullCreator()),
                {label: ('Times Processed'), hideSort: true}
            ),
            new TableFieldDescription(
                'availProcessses',
                new DataMapper('availProcessses'),
                new f.FilterDescription(new f.NullCreator()),
                {label: ('Avail Processes'), hideSort: true}
            ),
            new TableFieldDescription(
                'publishedProcesses',
                new DataMapper('publishedProcesses'),
                new f.FilterDescription(new f.NullCreator()),
                {label: ('Published Processes'), hideSort: true}
            ),
            new TableFieldDescription(
                'endDate',
                new DataMapper('period.endDate'),
                new f.FilterDescription(new f.DateFilter('endDate')),
                {label: ('End Date'), componentCreator: new DateComponentCreator(), excelDisplay: new DateDisplayCreator()}
            )
        ])

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(InvoiceInvoicePeriodsTableCreator)

export {
    InvoiceInvoicePeriodsTableCreator,
    InvoiceInvoicePeriodsTableCreatorQueries,
    companyPeriodActions
}
